import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import App from "./App";
import Root from "./root";

import "semantic-ui-css/semantic.min.css";
import "./index.scss";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

Sentry.init({
  dsn: "https://30fabef2bdaaf3ee9766b70210a900f9@o4509163999395841.ingest.us.sentry.io/4509237556543488",
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  enabled: String(process.env.REACT_APP_SENTRY_ENABLED) === "true",
  release: "placeorder@" + process.env.npm_package_version,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "system",
    }),
  ],
});

ReactDOM.render(
  <Root>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </Root>,
  document.getElementById("root")
);
